import Tree from "../../../../structure/tree";
import CommonRules from "../../../common/rules/common-rules";
import FlagFootballRules from "../list";
import Ruleset from "../../../football/enums/ruleset";
import FootballRules from "../../../football/rules/list";

const PatGame = new Tree(FlagFootballRules.General.IsPatGame, [
    new Tree(FlagFootballRules.General.SetTimeOnPlay, []),
    new Tree(FlagFootballRules.General.Drive.AddPlay, [
        new Tree(FootballRules.General.StartGame, [])
    ]),
    new Tree(FlagFootballRules.General.Scoring.Pat.Try, []),
    new Tree(FlagFootballRules.General.Scoring.Pat.RunStats, []),
    new Tree(FlagFootballRules.General.Scoring.Pat.Run, []),
    new Tree(FlagFootballRules.General.Scoring.Pat.PassStats, []),
    new Tree(FlagFootballRules.General.Scoring.Pat.Pass, []),
    new Tree(FlagFootballRules.General.Scoring.Pat.Complete, [
        new Tree(FlagFootballRules.General.Scoring.Pat.CompleteStats, [])
    ]),
    new Tree(FlagFootballRules.General.Scoring.Pat.Fail, []),
    new Tree(FlagFootballRules.General.Penalty.Accepted, [
        new Tree(FootballRules.General.StartGame, []),
        new Tree(FlagFootballRules.General.Penalty.AcceptedStats, [])
    ]),
    new Tree(FlagFootballRules.General.PlayEnd.Default, [
        new Tree(FlagFootballRules.General.Drive.CollectTime, [])
    ]),
    new Tree(FlagFootballRules.General.OvertimeDrive, []),
    new Tree(FlagFootballRules.General.ExtraOvertime, []),
    new Tree(FlagFootballRules.General.ResetField, []),
    new Tree(FlagFootballRules.General.FirstDown, []),
    new Tree(FlagFootballRules.General.FlagFirstDown, [])
]);

const RegularGame = new Tree(FlagFootballRules.General.IsRegularGame, [
    new Tree(FlagFootballRules.General.Timeout, []),
    new Tree(FlagFootballRules.General.UpdateContext, [
        new Tree(FlagFootballRules.General.UpdateContextStats, [])
    ]),
    new Tree(FlagFootballRules.General.SwapTeams, []),
    new Tree(FlagFootballRules.General.SetTimeAndPeriod, []),
    new Tree(FlagFootballRules.General.CoinToss, []),
    new Tree(FlagFootballRules.General.GameStart, []),
    new Tree(FlagFootballRules.General.StartPeriod, []),
    new Tree(FlagFootballRules.General.Drive.Create, []),
    new Tree(FlagFootballRules.General.SetTimeOnPlay, []),
    new Tree(FlagFootballRules.General.Drive.AddPlay, [
        new Tree(FootballRules.General.StartGame, [])
    ]),
    new Tree(FlagFootballRules.Offensive.Rush.RecordStats, []),
    new Tree(FlagFootballRules.Offensive.Rush.FieldChange, []),
    new Tree(FlagFootballRules.Offensive.SpikeStats, []),
    new Tree(FlagFootballRules.Offensive.Pass.Attempt.RecordStats, []),
    new Tree(FlagFootballRules.Offensive.Pass.Complete.RecordStatsReceiver, []),
    new Tree(FlagFootballRules.Offensive.Pass.Complete.FieldChange, []),
    new Tree(FlagFootballRules.Offensive.ContinuedStats, []),
    new Tree(FlagFootballRules.Offensive.Continued, []),
    new Tree(FlagFootballRules.Offensive.LateralStats, []),
    new Tree(FlagFootballRules.Offensive.Lateral, []),
    new Tree(FlagFootballRules.Offensive.KneelDownStats, []),
    new Tree(FlagFootballRules.Offensive.KneelDown, []),
    new Tree(
        FlagFootballRules.Offensive.Pass.Complete.RecordStatsQuarterback,
        []
    ),
    new Tree(FlagFootballRules.Offensive.Pass.Incomplete.RecordStats, []),
    new Tree(FlagFootballRules.Offensive.Pass.Interception.RecordStats, []),
    new Tree(FlagFootballRules.Offensive.Pass.Interception.FieldChange, []),
    new Tree(FlagFootballRules.Offensive.Pass.Sacked.RecordStats, []),
    new Tree(FlagFootballRules.Offensive.Pass.Sacked.FieldChange, []),
    new Tree(FlagFootballRules.Offensive.Fumble.RecordStats, []),
    new Tree(FlagFootballRules.Offensive.Fumble.RecoveryStats, []),
    new Tree(FlagFootballRules.Offensive.Fumble.Recovery, []),
    new Tree(FlagFootballRules.SpecialTeams.Punt.RecordStatsPunter, []),
    new Tree(FlagFootballRules.SpecialTeams.Punt.NoReturn.FieldChange, []),
    new Tree(FlagFootballRules.SpecialTeams.Punt.Return.FieldChange, []),
    new Tree(FlagFootballRules.SpecialTeams.Punt.Return.RecordStats, []),
    new Tree(
        FlagFootballRules.SpecialTeams.Punt.Return.PuntNoRecoveryReturnerStats,
        []
    ),
    new Tree(FlagFootballRules.SpecialTeams.Punt.TouchBack.RecordStats, []),
    new Tree(FlagFootballRules.SpecialTeams.Punt.Blocked.RecordStats, []),
    new Tree(FlagFootballRules.SpecialTeams.Punt.Blocked.Recovery, []),
    new Tree(FlagFootballRules.General.FairCatch, []),
    new Tree(FlagFootballRules.General.TouchBack, []),
    new Tree(FlagFootballRules.General.Returned, []),
    new Tree(FlagFootballRules.Defensive.Tackle.RecordStats, []),
    new Tree(FlagFootballRules.Defensive.OutOfBounds.RecordStats, []),
    new Tree(FlagFootballRules.Defensive.Safety.Punt, []),
    new Tree(FlagFootballRules.Defensive.Safety.Complete, [
        new Tree(FlagFootballRules.Defensive.Safety.RecordStats, [])
    ]),
    new Tree(FlagFootballRules.General.Penalty.Accepted, [
        new Tree(FootballRules.General.StartGame, []),
        new Tree(FlagFootballRules.General.Penalty.AcceptedStats, [])
    ]),
    new Tree(FlagFootballRules.General.PlayEnd.Default, [
        new Tree(FlagFootballRules.General.Scoring.Touchdown, [
            new Tree(FootballRules.Offensive.TouchdownStats, []),
            new Tree(
                FlagFootballRules.Offensive.Pass.Complete.RecordStatsTouchdown,
                []
            ),
            new Tree(
                FlagFootballRules.Offensive.Fumble.RecordStatsTouchdown,
                []
            ),
            new Tree(
                FlagFootballRules.Offensive.Pass.Interception.RecordStatsTouchdown,
                []
            ),
            new Tree(FlagFootballRules.Offensive.Rush.RecordStatsTouchdown, []),
            new Tree(
                FlagFootballRules.SpecialTeams.Punt.Return.RecordStatsTouchdown,
                []
            ),
            new Tree(
                FlagFootballRules.Offensive.Rush.ContinueTouchdownStats,
                []
            )
        ]),
        new Tree(FlagFootballRules.General.Drive.CollectTime, []),
        new Tree(FlagFootballRules.General.PlayEnd.Down, [
            new Tree(FlagFootballRules.General.AwardFirstDown, []),
            new Tree(FlagFootballRules.General.CountTouchdownsAsFirstDowns, [
                new Tree(FlagFootballRules.General.ChangeDownStats, [])
            ]),
            new Tree(FlagFootballRules.General.ChangeDown, [])
        ]),
        new Tree(FlagFootballRules.General.Turnover, []),
        new Tree(FlagFootballRules.General.Drive.EndDrive, [])
    ]),
    new Tree(FlagFootballRules.General.OvertimeDrive, []),
    new Tree(FlagFootballRules.General.ExtraOvertime, []),
    new Tree(FlagFootballRules.General.ResetField, [
        new Tree(FlagFootballRules.General.SafetyFieldSetup, [])
    ]),
    new Tree(FlagFootballRules.General.Finalize, [
        new Tree(FlagFootballRules.General.FirstDown, []),
        new Tree(FlagFootballRules.General.FlagFirstDown, [])
    ])
]);

//Rules are processed depth first
const DefaultFlagFootballRules = {
    id: Ruleset.DefaultFlagFootball.code,
    name: Ruleset.DefaultFlagFootball.name,
    rules: new Tree(CommonRules.Root, [PatGame, RegularGame])
};

export default DefaultFlagFootballRules;
